import { serviceAPI } from './api';

export interface Service {
  id: string;
  name: string;
  description?: string;
  price: number;
  duration: number;
  type?: string;
}

export const searchServices = async (query: string): Promise<Service[]> => {
  const response = await serviceAPI.get('/services/search', {
    params: { q: query }
  });
  return response.data.services || [];
};

export const getAllServices = async () => {
  const response = await serviceAPI.get('/services');
  return response.data;
};

export default serviceAPI;

